export const initialState = {
    "cmGradeModal" : false,
    "schoolCodeModal" : false,
    reportData:{},
    cmFluencyViewID : null
};
